import {IStorage} from "../IStorage";

export default class StorageDecorator implements IStorage {
  protected component: IStorage;

  constructor(component: IStorage) {
    this.component = component;
  }

  public clear(): void {
    this.component.clear();
  }

  public getItem(key: string): string {
    return this.component.getItem(key);
  }

  public removeItem(key: string): void {
    this.component.removeItem(key);
  }

  public setItem(key: string, value: string): void {
    this.component.setItem(key, value);
  }

}
